import { render, staticRenderFns } from "./ModeSwitching.vue?vue&type=template&id=347aee97&scoped=true"
import script from "./ModeSwitching.vue?vue&type=script&lang=js"
export * from "./ModeSwitching.vue?vue&type=script&lang=js"
import style0 from "./ModeSwitching.vue?vue&type=style&index=0&id=347aee97&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347aee97",
  null
  
)

export default component.exports